// extracted by mini-css-extract-plugin
module.exports = {"efAppPCB":"B_efAppPCB__RsXIR"};